var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"showPhoto",on:{"click":_vm.closeClick}},[_c('img',{staticClass:"img",attrs:{"src":_vm.url,"alt":"图片加载失败"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }